import Cookies from "js-cookie";
import { Navigate, Outlet } from "react-router-dom";
import Error404Page from "../../pages/PageNotFound/PageNotFound";
import constants from "../../utils/constants";

const ProtectedRoute = ({ allowedRoles }: { allowedRoles: number[] }) => {
  const token = constants.client_side_storage.accessToken
  const userRole: any = constants.client_side_storage.userDetails.is_admin;

  const role = userRole ? 1 : 0

  if (!token) {
    return <Navigate to={constants.navigationUrls.login} />;
  }
 
  if (!allowedRoles.includes(role)) {
    return <Error404Page />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
